<div class="dispatch-planner">
  <div class="dispatch-planner-toolbar">
    <h2>Dispatch Planner</h2>
    <span class="toolbar-meta" *ngIf="loadingGeocode">Geocoding läuft …</span>
    <span class="toolbar-meta" *ngIf="rollerSoapLoading">Roller SOAP läuft …</span>
    <span class="toolbar-meta" *ngIf="!loadingGeocode && !rollerSoapLoading">
      {{ availableStops.length }} Import<ng-container *ngIf="deliverySuggestionStops.length"> · {{ deliverySuggestionStops.length }} LV</ng-container><ng-container *ngFor="let plannerTeam of teams"> · {{ plannerTeam.label }}: {{ plannerTeam.stops.length }}</ng-container> · {{ mappedStops.length + mappedCalendarAppointments.length }} Marker
    </span>

    <label class="btn btn-outline-secondary btn-add csv-upload-label">
      <i class="feather ft-upload"></i>
      CSV importieren
      <input
        #csvInput
        type="file"
        accept=".csv,text/csv"
        class="csv-input-hidden"
        (change)="onCsvSelected($event)"
      />
    </label>
    <label class="btn btn-outline-secondary btn-add csv-upload-label">
      <i class="feather ft-file-text"></i>
      Liefervorschlag
      <input
        #deliverySuggestionInput
        type="file"
        accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
        class="csv-input-hidden"
        (change)="onDeliverySuggestionSelected($event)"
      />
    </label>
    <button type="button" class="btn btn-primary btn-add" (click)="openImportDialog()" title="Text importieren">
      <i class="feather ft-plus"></i>
      Text importieren
    </button>
    <button
      type="button"
      class="btn btn-outline-primary btn-add"
      (click)="openRollerSoapDialog()"
      [disabled]="rollerSoapLoading"
      title="Aufträge per Roller SOAP (getTouren) laden"
    >
      <i class="feather ft-plus"></i>
      Roller SOAP
    </button>

    <div class="list-view-toggle" role="group" aria-label="Listenansicht">
      <button
        type="button"
        class="btn btn-sm list-view-btn"
        [class.active]="listViewMode === 'detail'"
        (click)="setListViewMode('detail')"
        title="Alle Details pro Auftrag"
      >
        Details
      </button>
      <button
        type="button"
        class="btn btn-sm list-view-btn"
        [class.active]="listViewMode === 'compact'"
        (click)="setListViewMode('compact')"
        title="Kompakt: KV, Küche/Möbel, M/L/Z/G/Zeit"
      >
        Kompakt
      </button>
    </div>

    <div class="list-panel-toggle" role="group" aria-label="Listen ein- und ausblenden">
      <button
        type="button"
        class="btn btn-sm list-panel-btn"
        [class.active]="importPanelVisible"
        (click)="toggleListPanel('import')"
        title="Importliste ein-/ausblenden"
      >
        Import
        <span class="list-panel-btn-count" *ngIf="availableStops.length">{{ availableStops.length }}</span>
      </button>
      <button
        type="button"
        class="btn btn-sm list-panel-btn list-panel-btn-lv"
        [class.active]="deliverySuggestionPanelVisible"
        (click)="toggleListPanel('deliverySuggestion')"
        title="Liefervorschlagsliste ein-/ausblenden"
      >
        LV
        <span class="list-panel-btn-count" *ngIf="deliverySuggestionStops.length">{{ deliverySuggestionStops.length }}</span>
      </button>
      <button
        type="button"
        class="btn btn-sm list-panel-btn"
        [class.active]="teamOverviewSidebarVisible"
        (click)="teamOverviewSidebarVisible = !teamOverviewSidebarVisible"
        title="Team-Übersicht ein-/ausblenden"
      >
        Teams
        <span class="list-panel-btn-count">{{ teams.length }}</span>
      </button>
    </div>
  </div>

  <div *ngIf="csvImportError" class="alert alert-danger csv-alert">{{ csvImportError }}</div>
  <div *ngIf="deliverySuggestionImportError" class="alert alert-danger csv-alert">{{ deliverySuggestionImportError }}</div>

  <div class="dispatch-planner-body">
    <div class="map-panel">
      <div class="map-tools">
        <div class="map-tool-group">
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="selectionTool === 'pan'"
            (click)="setSelectionTool('pan')"
            title="Karte verschieben"
          >
            <i class="feather ft-move"></i>
            Verschieben
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="selectionTool === 'rectangle'"
            (click)="setSelectionTool('rectangle')"
            title="Rechteck-Auswahl"
          >
            <i class="feather ft-square"></i>
            Rechteck
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="selectionTool === 'lasso'"
            (click)="setSelectionTool('lasso')"
            title="Lasso-Auswahl"
          >
            <i class="feather ft-edit-2"></i>
            Lasso
          </button>
        </div>

        <div class="map-tool-group map-tool-group-maptypes">
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="mapTypeId === 'roadmap'"
            (click)="setMapType('roadmap')"
            title="Kartenansicht"
          >
            <i class="feather ft-map"></i>
            Karte
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="mapTypeId === 'satellite'"
            (click)="setMapType('satellite')"
            title="Satellitenansicht"
          >
            <i class="feather ft-globe"></i>
            Satellit
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="mapTypeId === 'hybrid'"
            (click)="setMapType('hybrid')"
            title="Hybridansicht"
          >
            Hybrid
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="mapTilt === 0"
            (click)="setMap2D()"
            title="2D-Ansicht"
          >
            2D
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="mapTilt > 0"
            (click)="setMap3D()"
            title="3D-Ansicht (Satellit/Hybrid)"
          >
            3D
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="streetViewActive"
            (click)="toggleStreetView()"
            title="Street View (ausgewählter Auftrag oder Kartenmitte)"
          >
            <i class="feather ft-eye"></i>
            Street View
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            [class.active]="markerInfoLabelsVisible"
            (click)="toggleMarkerInfoLabels()"
            title="Marker-Beschriftung: Auftragsnummer, Nachname, Lieferung/Montage und Artikel anzeigen"
          >
            <i class="feather ft-tag"></i>
            Tooltip
          </button>
        </div>

        <div class="map-tool-group map-tool-group-teams">
          <button
            type="button"
            class="btn btn-sm map-tool-btn"
            *ngFor="let plannerTeam of teams"
            [class.active]="activeTourTeam === plannerTeam.id"
            [style.--team-color]="getTeamColor(plannerTeam.id)"
            [class.map-tool-btn-team-dynamic]="true"
            (click)="setActiveTourTeam(plannerTeam.id)"
            [title]="'Tour / Route für ' + plannerTeam.label"
          >
            {{ plannerTeam.label }}
          </button>
        </div>

        <div class="map-tool-group map-tool-group-actions">
          <button
            type="button"
            class="btn btn-sm map-tool-btn map-tool-btn-accent"
            (click)="calculateTour()"
            [disabled]="!canCalculateTour(activeTourTeam) || tourCalculating"
            [title]="'Route für Team ' + activeTourTeam + ' berechnen'"
          >
            <i class="feather ft-navigation"></i>
            {{ tourCalculating ? 'Tour …' : 'Tour berechnen' }}
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn map-tool-btn-accent"
            (click)="generatePdf()"
            [disabled]="!activeTeamStops.length"
            [title]="'Team ' + activeTourTeam + ' als PDF'"
          >
            <i class="feather ft-file-text"></i>
            PDF
          </button>
          <button
            type="button"
            class="btn btn-sm map-tool-btn map-tool-btn-accent"
            (click)="openEmailDialog()"
            [disabled]="!allTeamStops().length"
            title="E-Mails an Kunden senden"
          >
            <i class="feather ft-mail"></i>
            E-Mails
          </button>
        </div>

        <div class="map-tool-actions" *ngIf="selectedStopIds.length">
          <span class="map-selection-count">{{ selectedStopIds.length }} ausgewählt</span>
          <button type="button" class="btn btn-link btn-sm" (click)="clearMapSelection()">Auswahl löschen</button>
        </div>

        <span class="map-tool-hint tour-result" *ngIf="tourDistance || tourDuration">
          <i class="feather ft-navigation"></i>
          Team {{ activeTourTeam }}: {{ tourDistance }}<span *ngIf="tourDuration"> · {{ tourDuration }}</span>
        </span>
        <span class="map-tool-hint tour-result" *ngIf="allTeamStops().length && teamKostenGesamt > 0">
          <i class="feather ft-dollar-sign"></i>
          Teams gesamt: {{ formatCurrency(teamKostenGesamt) }}
          <span class="text-muted"> (Lieferung + Montage VK)</span>
        </span>
        <span class="map-tool-hint" *ngIf="selectionTool === 'rectangle'">Rechteck aufziehen · alle Marker in der Fläche · Shift = hinzufügen</span>
        <span class="map-tool-hint" *ngIf="selectionTool === 'lasso'">Freihand um Marker zeichnen · Shift = hinzufügen</span>
      </div>

      <div class="map-panel-inner" #mapContainer>
        <agm-map
          [latitude]="centerLat"
          [longitude]="centerLng"
          [zoom]="zoom"
          [mapTypeId]="mapTypeId"
          [tilt]="mapTilt"
          [mapTypeControl]="false"
          [streetViewControl]="true"
          [fullscreenControl]="true"
          (mapReady)="onMapReady($event)"
        ></agm-map>

        <svg
          *ngIf="selectionTool !== 'pan'"
          class="map-selection-overlay"
          [class.drawing]="isDrawingSelection"
          [ngStyle]="mapSelectionOverlayLayout"
        >
          <rect
            *ngIf="selectionTool === 'rectangle' && selectionRectForDisplay"
            class="selection-shape"
            [attr.x]="selectionRectForDisplay.x"
            [attr.y]="selectionRectForDisplay.y"
            [attr.width]="selectionRectForDisplay.width"
            [attr.height]="selectionRectForDisplay.height"
          ></rect>
          <polyline
            *ngIf="selectionTool === 'lasso' && lassoPoints.length > 1"
            class="selection-shape selection-lasso-line"
            [attr.points]="lassoSvgPoints"
          ></polyline>
          <polygon
            *ngIf="selectionTool === 'lasso' && lassoPoints.length > 2"
            class="selection-shape selection-lasso-fill"
            [attr.points]="lassoSvgPoints"
          ></polygon>
        </svg>

        <div
          *ngIf="selectionTool !== 'pan'"
          class="map-selection-capture"
          [ngStyle]="mapSelectionOverlayLayout"
          (mousedown)="onOverlayMouseDown($event)"
          (mousemove)="onOverlayMouseMove($event)"
          (mouseup)="onOverlayMouseUp($event)"
        ></div>
      </div>

      <div class="map-legend">
        <span class="legend-item"><span class="legend-dot legend-kueche"></span> Küche</span>
        <span class="legend-item"><span class="legend-dot legend-moebel"></span> Möbel</span>
        <span class="legend-item"><span class="legend-dot legend-other"></span> Sonstiges</span>
        <span class="legend-item legend-muted"><span class="legend-dot legend-kueche legend-dot-muted"></span> Import (offen)</span>
        <span class="legend-item" *ngIf="deliverySuggestionStops.length"><span class="legend-dot legend-delivery-suggestion"></span> Liefervorschlag</span>
        <span class="legend-item" *ngFor="let plannerTeam of teams; let i = index">
          <span class="legend-dot" [style.background]="getTeamColor(plannerTeam.id)"></span>
          {{ plannerTeam.label }} (nummeriert)
        </span>
        <span class="legend-item" *ngIf="selectedBranchId"><span class="legend-dot legend-branch"></span> Filiale (Start/Ende)</span>
        <span class="legend-item" *ngIf="hasBranchWaypoint()"><span class="legend-dot legend-radius-inner"></span> {{ branchInnerRadiusKm }} km Radius</span>
        <span class="legend-item" *ngIf="hasBranchWaypoint()"><span class="legend-dot legend-radius"></span> {{ branchRadiusKm }} km Radius</span>
        <span class="legend-item"><span class="legend-dot legend-calendar"></span> Kalender-Termin (fix)</span>
      </div>
    </div>

    <div
      class="lists-panel"
      *ngIf="hasAnyListPanelVisible()"
      cdkDropListGroup
      [class.list-view-compact]="isCompactListView()"
    >
      <!-- Importliste -->
      <aside class="list-panel available-panel" *ngIf="importPanelVisible">
        <div class="list-panel-header">
          <h3>Import</h3>
          <span class="badge badge-secondary">{{ availableStops.length }}</span>
          <button
            type="button"
            class="btn btn-link btn-sm list-panel-hide-btn"
            title="Liste ausblenden"
            (click)="toggleListPanel('import')"
          >
            <i class="feather ft-x"></i>
          </button>
        </div>

        <div class="available-selection-bar">
          <button
            type="button"
            class="btn btn-sm btn-add-to-team"
            *ngFor="let plannerTeam of teams"
            [style.--team-color]="getTeamColor(plannerTeam.id)"
            [class.btn-primary]="plannerTeam.id === teams[0]?.id"
            [class.btn-outline-primary]="plannerTeam.id !== teams[0]?.id"
            (click)="addSelectedToTeam(plannerTeam.id)"
            [disabled]="!selectedAvailableCount"
          >
            In {{ plannerTeam.label }}
            <span *ngIf="selectedAvailableCount"> ({{ selectedAvailableCount }})</span>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-auto-dispatch"
            (click)="autoDispatchStops()"
            [disabled]="!canAutoDispatch()"
            title="Automatisch disponieren."
            aria-label="Automatisch disponieren."
          >
            <i class="feather ft-zap"></i>
          </button>
          <label class="filiale-assign-label" for="dispatchBranchSelect">Filiale</label>
          <select
            id="dispatchBranchSelect"
            class="form-control form-control-sm filiale-select"
            [ngModel]="selectedBranchId"
            (ngModelChange)="onBranchSelected($event)"
            [compareWith]="compareBranchId"
            [disabled]="plannerDataLoading || !branches.length"
          >
            <option [ngValue]="null">– wählen –</option>
            <option *ngFor="let branch of branches" [ngValue]="branch.id">{{ branch.label }}</option>
          </select>
          <button
            type="button"
            class="btn btn-link btn-sm btn-clear-selection"
            (click)="clearMapSelection()"
            [disabled]="!selectedStopIds.length"
          >
            Auswahl löschen
          </button>
        </div>
        <p
          class="filiale-assign-hint text-muted"
          *ngIf="plannerDataLoading || branchLocationLoading || (selectedBranchId && !teamOptions.length)"
        >
          <span *ngIf="plannerDataLoading">Lade Filialen …</span>
          <span *ngIf="!plannerDataLoading && branchLocationLoading">Lade Filial-Koordinaten …</span>
          <span *ngIf="!plannerDataLoading && !branchLocationLoading && selectedBranchId && !teamOptions.length">Keine Teams für diese Filiale</span>
        </p>

        <p class="list-panel-hint">Importierte Aufträge – in Teams ziehen oder aus Teams zurück.</p>

        <div
          #availableListContainer
          class="drop-list drop-list-import"
          cdkDropList
          cdkDropListOrientation="vertical"
          [id]="availableListId"
          [cdkDropListData]="availableStops"
          (cdkDropListDropped)="onListDrop($event)"
        >
          <div class="drop-list-empty" *ngIf="availableStops.length === 0">
            <p>Keine offenen Aufträge.</p>
            <p class="text-muted">Aufträge aus Team 1 / Team 2 hierher ziehen.</p>
          </div>

          <div
            class="roll-card-item"
            [class.roll-card-item-compact]="isCompactListView()"
            *ngFor="let stop of availableStops; trackBy: trackStopById"
            cdkDrag
            cdkDragPreviewClass="dispatch-planner-drag-preview"
            title="Ziehen zum Verschieben in andere Liste"
            [attr.data-stop-id]="stop.id"
            [class.active]="isListActive(stop)"
            [class.map-selected]="isMapSelected(stop)"
            [class.marker-focused]="isMarkerFocused(stop)"
            [class.roll-card-kueche]="stop.kontingent === 'kueche'"
            [class.roll-card-moebel]="stop.kontingent === 'moebel'"
            [class.roll-card-outside-radius]="isStopOutsideBranchRadius(stop)"
            (click)="selectStop(stop, $event)"
          >
            <ng-container *ngIf="!isCompactListView(); else availableCompactRow">
              <div class="roll-card-detail-layout">
                <div class="roll-card-detail-topbar">
                  <div class="roll-card-detail-drag-area">
                    <div class="drag-handle">
                      <i class="feather ft-menu"></i>
                    </div>
                    <ng-container *ngTemplateOutlet="stopDetailHeader; context: { $implicit: stop }"></ng-container>
                  </div>
                  <button
                    type="button"
                    class="btn btn-link btn-sm roll-card-remove"
                    title="Auftrag entfernen"
                    (mousedown)="$event.stopPropagation()"
                    (click)="removeFromAvailable(stop, $event)"
                  >
                    <i class="feather ft-x"></i>
                  </button>
                </div>
                <ng-container *ngTemplateOutlet="stopDetailBody; context: { $implicit: stop }"></ng-container>
              </div>
            </ng-container>
            <ng-template #availableCompactRow>
              <div class="roll-card-item-row">
                <div class="drag-handle">
                  <i class="feather ft-menu"></i>
                </div>
                <ng-container *ngTemplateOutlet="stopDetailsCompact; context: { $implicit: stop }"></ng-container>
                <button
                  type="button"
                  class="btn btn-link btn-sm roll-card-remove"
                  title="Auftrag entfernen"
                  (mousedown)="$event.stopPropagation()"
                  (click)="removeFromAvailable(stop, $event)"
                >
                  <i class="feather ft-x"></i>
                </button>
              </div>
            </ng-template>
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
          </div>
        </div>
      </aside>

      <!-- Liefervorschlagsliste -->
      <aside class="list-panel delivery-suggestion-panel" *ngIf="deliverySuggestionPanelVisible">
        <div class="list-panel-header">
          <h3>Liefervorschlag</h3>
          <span class="badge badge-secondary">{{ deliverySuggestionStops.length }}</span>
          <button
            type="button"
            class="btn btn-link btn-sm list-panel-hide-btn"
            title="Liste ausblenden"
            (click)="toggleListPanel('deliverySuggestion')"
          >
            <i class="feather ft-x"></i>
          </button>
        </div>

        <div class="available-selection-bar">
          <button
            type="button"
            class="btn btn-sm btn-add-to-team"
            *ngFor="let plannerTeam of teams"
            [style.--team-color]="getTeamColor(plannerTeam.id)"
            [class.btn-primary]="plannerTeam.id === teams[0]?.id"
            [class.btn-outline-primary]="plannerTeam.id !== teams[0]?.id"
            (click)="addSelectedDeliverySuggestionToTeam(plannerTeam.id)"
            [disabled]="!selectedDeliverySuggestionCount"
          >
            In {{ plannerTeam.label }}
            <span *ngIf="selectedDeliverySuggestionCount"> ({{ selectedDeliverySuggestionCount }})</span>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-auto-dispatch"
            (click)="autoDispatchDeliverySuggestionStops()"
            [disabled]="!canAutoDispatchDeliverySuggestion()"
            title="Alle Liefervorschläge automatisch auf die Teams verteilen (optimale Fahrtrichtung)."
            aria-label="Liefervorschläge automatisch disponieren."
          >
            <i class="feather ft-zap"></i>
          </button>
        </div>

        <p class="list-panel-hint">Liefervorschläge – graue Marker, in Teams ziehen oder automatisch disponieren.</p>

        <div
          #deliverySuggestionListContainer
          class="drop-list drop-list-delivery-suggestion"
          cdkDropList
          cdkDropListOrientation="vertical"
          [id]="deliverySuggestionListId"
          [cdkDropListData]="deliverySuggestionStops"
          (cdkDropListDropped)="onListDrop($event)"
        >
          <div class="drop-list-empty" *ngIf="deliverySuggestionStops.length === 0">
            <p>Keine Liefervorschläge.</p>
            <p class="text-muted">Excel (.xlsx) über „Liefervorschlag“ hochladen.</p>
          </div>

          <div
            class="roll-card-item roll-card-delivery-suggestion"
            [class.roll-card-item-compact]="isCompactListView()"
            *ngFor="let stop of deliverySuggestionStops; trackBy: trackStopById"
            cdkDrag
            cdkDragPreviewClass="dispatch-planner-drag-preview"
            title="Ziehen zum Verschieben in andere Liste"
            [attr.data-stop-id]="stop.id"
            [class.active]="isListActive(stop)"
            [class.map-selected]="isMapSelected(stop)"
            [class.marker-focused]="isMarkerFocused(stop)"
            [class.roll-card-outside-radius]="isStopOutsideBranchRadius(stop)"
            (click)="selectStop(stop, $event)"
          >
            <ng-container *ngIf="!isCompactListView(); else deliverySuggestionCompactRow">
              <div class="roll-card-detail-layout">
                <div class="roll-card-detail-topbar">
                  <div class="roll-card-detail-drag-area">
                    <div class="drag-handle">
                      <i class="feather ft-menu"></i>
                    </div>
                    <ng-container *ngTemplateOutlet="stopDetailHeader; context: { $implicit: stop }"></ng-container>
                  </div>
                  <button
                    type="button"
                    class="btn btn-link btn-sm roll-card-remove"
                    title="Liefervorschlag entfernen"
                    (mousedown)="$event.stopPropagation()"
                    (click)="removeFromDeliverySuggestion(stop, $event)"
                  >
                    <i class="feather ft-x"></i>
                  </button>
                </div>
                <ng-container *ngTemplateOutlet="stopDetailBody; context: { $implicit: stop }"></ng-container>
              </div>
            </ng-container>
            <ng-template #deliverySuggestionCompactRow>
              <div class="roll-card-item-row">
                <div class="drag-handle">
                  <i class="feather ft-menu"></i>
                </div>
                <ng-container *ngTemplateOutlet="stopDetailsCompact; context: { $implicit: stop }"></ng-container>
                <button
                  type="button"
                  class="btn btn-link btn-sm roll-card-remove"
                  title="Liefervorschlag entfernen"
                  (mousedown)="$event.stopPropagation()"
                  (click)="removeFromDeliverySuggestion(stop, $event)"
                >
                  <i class="feather ft-x"></i>
                </button>
              </div>
            </ng-template>
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
          </div>
        </div>
      </aside>

      <!-- Team-Detail (aktives Team) -->
      <aside
        class="list-panel team-panel team-panel-dynamic"
        *ngFor="let plannerTeam of teams"
        [ngStyle]="getTeamColorStyle(plannerTeam.id)"
        [hidden]="!(plannerTeam.detailPanelVisible && activeDetailTeamId === plannerTeam.id)"
      >
        <ng-container
          *ngTemplateOutlet="
            teamPanelToolbar;
            context: {
              team: plannerTeam.id,
              teamLabel: plannerTeam.label,
              stops: plannerTeam.stops,
              calendarAppointments: plannerTeam.calendarAppointments,
              panelKey: getTeamPanelKey(plannerTeam.id)
            }
          "
        ></ng-container>
        <div class="team-list-stack">
          <div class="team-calendar-fixed-list" *ngIf="plannerTeam.calendarAppointments?.length">
            <ng-container *ngTemplateOutlet="teamCalendarBody; context: { team: plannerTeam.id, calendarAppointments: plannerTeam.calendarAppointments }"></ng-container>
          </div>
          <div
            class="drop-list drop-list-team"
            cdkDropList
            cdkDropListOrientation="vertical"
            [id]="getTeamListId(plannerTeam.id)"
            [cdkDropListData]="plannerTeam.stops"
            (cdkDropListDropped)="onListDrop($event)"
          >
            <div class="drop-list-empty" *ngIf="!plannerTeam.stops.length">
              <p>Keine planbaren Aufträge.</p>
              <p class="text-muted">Aufträge aus Import oder anderen Teams hierher ziehen.</p>
            </div>
            <div
              class="roll-card-item"
              [class.roll-card-item-compact]="isCompactListView()"
              [class.roll-card-duplicate]="isDuplicateStop(stop)"
              *ngFor="let stop of plannerTeam.stops; let i = index; trackBy: trackStopById"
              cdkDrag
              cdkDragPreviewClass="dispatch-planner-drag-preview"
              title="Ziehen zum Sortieren oder in andere Liste verschieben"
              [attr.data-stop-id]="stop.id"
              [class.active]="isListActive(stop)"
              [class.map-selected]="isMapSelected(stop)"
              [class.marker-focused]="isMarkerFocused(stop)"
              [class.roll-card-kueche]="stop.kontingent === 'kueche'"
              [class.roll-card-moebel]="stop.kontingent === 'moebel'"
              [class.roll-card-outside-radius]="isStopOutsideBranchRadius(stop)"
              (click)="selectStop(stop, $event)"
            >
              <ng-container *ngTemplateOutlet="teamStopCard; context: { team: plannerTeam.id, stop: stop, i: i, stops: plannerTeam.stops, indexClass: 'team-index-dynamic' }"></ng-container>
              <div class="drag-placeholder" *cdkDragPlaceholder></div>
            </div>
          </div>
        </div>
      </aside>
    </div>

    <aside class="team-overview-sidebar" *ngIf="teamOverviewSidebarVisible">
      <div class="team-overview-header">
        <h3>Teams</h3>
        <button
          type="button"
          class="btn btn-sm btn-outline-primary team-overview-add-btn"
          (click)="addPlannerTeam()"
          title="Neues Team anlegen"
        >
          <i class="feather ft-plus"></i>
        </button>
      </div>

      <div class="team-overview-list">
        <button
          type="button"
          class="team-overview-card"
          *ngFor="let plannerTeam of teams"
          [class.active]="activeDetailTeamId === plannerTeam.id"
          [ngStyle]="getTeamColorStyle(plannerTeam.id)"
          (click)="selectTeamForDetail(plannerTeam.id)"
        >
          <div class="team-overview-card-head">
            <span class="team-overview-dot"></span>
            <div class="team-overview-title-wrap">
              <span class="team-overview-title">{{ plannerTeam.label }}</span>
              <span class="team-overview-monteur" *ngIf="getTeamBaseLabelForSlot(plannerTeam.id)">
                {{ getTeamBaseLabelForSlot(plannerTeam.id) }}
              </span>
            </div>
            <span class="team-overview-count">{{ getTeamStopCount(plannerTeam.id) + getTeamCalendarCount(plannerTeam.id) }}</span>
            <button
              type="button"
              class="btn btn-link btn-sm team-overview-remove-btn"
              *ngIf="teams.length > 1"
              (click)="removePlannerTeam(plannerTeam.id, $event)"
              title="Leeres Team entfernen"
            >
              <i class="feather ft-trash-2"></i>
            </button>
          </div>

          <div class="team-overview-base-select" (click)="$event.stopPropagation()">
            <select
              class="form-control form-control-sm team-overview-base-select-input"
              [id]="'teamOverviewBaseSelect' + plannerTeam.id"
              [ngModel]="getTeamBaseIdForSlot(plannerTeam.id)"
              (ngModelChange)="onTeamBaseSelected(plannerTeam.id, $event)"
              [disabled]="!selectedBranchId || !teamOptions.length"
            >
              <option [ngValue]="null">Monteur-Team wählen …</option>
              <option *ngFor="let tb of getTeamBaseOptionsForSlot(plannerTeam.id)" [ngValue]="tb.id">
                {{ tb.label }}{{ tb.isStammteam ? ' (Stamm)' : '' }}
              </option>
            </select>
          </div>

          <div class="team-overview-metrics">
            <span class="team-overview-metric" *ngIf="getTourDistanceForTeam(plannerTeam.id)">
              <i class="feather ft-navigation"></i>{{ getTourDistanceForTeam(plannerTeam.id) }}
            </span>
            <span class="team-overview-metric" *ngIf="getTourDurationForTeam(plannerTeam.id)">
              <i class="feather ft-clock"></i>{{ getTourDurationForTeam(plannerTeam.id) }}
            </span>
            <span class="team-overview-metric" *ngIf="getTeamUmsatz(plannerTeam.id) > 0">
              <i class="feather ft-dollar-sign"></i>{{ formatCurrency(getTeamUmsatz(plannerTeam.id)) }}
            </span>
          </div>

          <div class="team-overview-categories" *ngIf="getTeamCategoryBreakdown(plannerTeam.id).length">
            <span
              class="team-overview-category"
              *ngFor="let category of getTeamCategoryBreakdown(plannerTeam.id)"
            >
              {{ category.label }}: {{ category.count }}
            </span>
          </div>

          <div class="team-overview-loading text-muted" *ngIf="isTeamTourCalculating(plannerTeam.id)">
            Tour wird berechnet …
          </div>
        </button>
      </div>
    </aside>
  </div>

  <button type="button" class="fab-add" (click)="openCsvPicker()" title="CSV importieren">
    <i class="feather ft-upload"></i>
  </button>
</div>

<ng-template
  #teamPanelToolbar
  let-team="team"
  let-teamLabel="teamLabel"
  let-stops="stops"
  let-calendarAppointments="calendarAppointments"
  let-panelKey="panelKey"
>
    <div class="list-panel-header">
      <h3>{{ teamLabel || ('Team ' + team) }}</h3>
      <span class="badge badge-secondary">{{ stops.length + (calendarAppointments?.length || 0) }}</span>
      <button
        type="button"
        class="btn btn-link btn-sm list-panel-hide-btn"
        title="Liste ausblenden"
        (click)="toggleListPanel(panelKey)"
      >
        <i class="feather ft-x"></i>
      </button>
    </div>
    <div class="team-base-select-row">
      <label class="team-base-select-label" [attr.for]="'teamBaseSelect' + team">Monteur-Team</label>
      <select
        class="form-control form-control-sm team-base-select"
        [id]="'teamBaseSelect' + team"
        [ngModel]="getTeamBaseIdForSlot(team)"
        (ngModelChange)="onTeamBaseSelected(team, $event)"
        [disabled]="!selectedBranchId || !teamOptions.length"
      >
        <option [ngValue]="null">– Team wählen –</option>
        <option *ngFor="let tb of getTeamBaseOptionsForSlot(team)" [ngValue]="tb.id">
          {{ tb.label }}{{ tb.isStammteam ? ' (Stamm)' : '' }}
        </option>
      </select>
    </div>
    <p class="team-base-selected text-muted" *ngIf="getTeamBaseLabelForSlot(team)">
      {{ getTeamBaseLabelForSlot(team) }}
      <span *ngIf="getPlanningDateLabel()"> · Tag: {{ getPlanningDateLabel() }}</span>
    </p>
    <p class="team-calendar-hint text-muted" *ngIf="getTeamBaseIdForSlot(team) && calendarAppointmentsLoading">
      Kalender-Termine werden geladen …
    </p>

    <div class="list-panel-actions">
      <button type="button" class="btn btn-link btn-sm" (click)="addAllToTeam(team)" [disabled]="!availableStops.length">
        Alle aus Import
      </button>
      <button
        type="button"
        class="btn btn-link btn-sm"
        (click)="optimizeTour(team)"
        [disabled]="!canOptimizeTour(team) || isTeamTourCalculating(team)"
      >
        Tour optimieren
      </button>
      <button type="button" class="btn btn-link btn-sm text-danger" (click)="clearTeam(team)" [disabled]="!stops.length">
        Leeren
      </button>
    </div>

    <div class="team-tour-summary" *ngIf="stops.length">
      <span class="team-tour-stat" *ngIf="getTeamUmsatz(team) > 0">
        <i class="feather ft-dollar-sign"></i>
        {{ formatCurrency(getTeamUmsatz(team)) }}
      </span>
      <span class="team-tour-stat" *ngIf="getTourDistanceForTeam(team)">
        <i class="feather ft-navigation"></i>
        {{ getTourDistanceForTeam(team) }}
      </span>
      <span class="team-tour-stat" *ngIf="getTourDurationForTeam(team)">
        <i class="feather ft-clock"></i>
        {{ getTourDurationForTeam(team) }}
      </span>
      <span class="team-tour-stat team-tour-loading" *ngIf="isTeamTourCalculating(team)">
        Tour wird berechnet …
      </span>
    </div>
</ng-template>

<ng-template #teamCalendarBody let-team="team" let-calendarAppointments="calendarAppointments">
  <div
    class="roll-card-item roll-card-item-calendar"
    [class.roll-card-item-compact]="isCompactListView()"
    [class.roll-card-duplicate]="isDuplicateCalendarAppointment(appointment)"
    [class.team-calendar-item]="true"
    [ngStyle]="getTeamColorStyle(team)"
    *ngFor="let appointment of calendarAppointments; trackBy: trackCalendarAppointment"
    [attr.data-calendar-id]="appointment.id"
  >
    <div class="roll-card-item-row roll-card-item-row-calendar">
      <div class="roll-card-index roll-card-index-calendar" title="Kalender-Termin (fix)">
        <i class="feather ft-calendar"></i>
      </div>
      <div class="roll-card-content">
        <div class="roll-card-topline">
          <span
            class="badge calendar-type-badge"
            [style.background-color]="appointment.typeColor"
            [style.color]="'#fff'"
          >
            {{ appointment.typeName }}
          </span>
          <span class="calendar-time-badge">{{ appointment.timeLabel }}</span>
          <span class="badge badge-secondary calendar-fixed-badge">Kalender</span>
          <span class="badge badge-danger duplicate-badge" *ngIf="isDuplicateCalendarAppointment(appointment)">Doppelt</span>
        </div>
        <div class="roll-card-customer">{{ appointment.title }}</div>
        <div class="roll-card-address" *ngIf="appointment.address">{{ appointment.address }}</div>
        <div class="roll-card-meta text-muted" *ngIf="appointment.orderNumber">
          Auftrag {{ appointment.orderNumber }}
          <span *ngIf="appointment.reserved"> · Reserviert</span>
          <span *ngIf="appointment.isCanceled"> · Storniert</span>
        </div>
      </div>
      <span class="calendar-lock-icon" title="Termin ist im Kalender gebucht und nicht verschiebbar">
        <i class="feather ft-lock"></i>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #teamStopCard let-team="team" let-stop="stop" let-i="i" let-stops="stops" let-indexClass="indexClass">
  <div class="tour-segment" *ngIf="isCompactListView() && getTourLegBeforeStop(team, i) as leg">
    <span class="tour-segment-line" aria-hidden="true"></span>
    <span class="tour-segment-text">
      <i class="feather ft-navigation"></i>
      {{ leg.distance_text }}
      <span class="tour-segment-sep">·</span>
      <i class="feather ft-clock"></i>
      {{ leg.duration_text }}
    </span>
    <span class="tour-segment-line" aria-hidden="true"></span>
  </div>

  <ng-container *ngIf="!isCompactListView(); else teamCompactRow">
    <div class="roll-card-detail-layout">
      <div class="roll-card-detail-topbar">
        <div class="roll-card-detail-drag-area">
          <div class="roll-card-index drag-handle" [ngClass]="indexClass">
            {{ stop.orderIndex }}
          </div>
          <ng-container *ngTemplateOutlet="stopDetailHeader; context: { $implicit: stop, tourLeg: getTourLegBeforeStop(team, i) }"></ng-container>
        </div>
        <div class="roll-card-detail-actions">
          <div class="roll-card-reorder-actions">
            <button
              type="button"
              class="btn btn-link btn-sm roll-card-reorder"
              title="Nach oben"
              [disabled]="i === 0"
              (mousedown)="$event.stopPropagation()"
              (click)="moveStopInTeam(team, i, -1, $event)"
            >
              <i class="feather ft-chevron-up"></i>
            </button>
            <button
              type="button"
              class="btn btn-link btn-sm roll-card-reorder"
              title="Nach unten"
              [disabled]="i === stops.length - 1"
              (mousedown)="$event.stopPropagation()"
              (click)="moveStopInTeam(team, i, 1, $event)"
            >
              <i class="feather ft-chevron-down"></i>
            </button>
          </div>
          <button
            type="button"
            class="btn btn-link btn-sm roll-card-remove"
            title="Zurück in {{ stop.source === 'delivery-suggestion' ? 'Liefervorschlag' : 'Import' }}"
            (mousedown)="$event.stopPropagation()"
            (click)="removeFromTeam(stop, team, $event)"
          >
            <i class="feather ft-x"></i>
          </button>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="stopDetailBody; context: { $implicit: stop }"></ng-container>
    </div>
  </ng-container>
  <ng-template #teamCompactRow>
    <div class="roll-card-item-row">
      <div class="roll-card-index drag-handle" [ngClass]="indexClass">
        {{ stop.orderIndex }}
      </div>
      <ng-container *ngTemplateOutlet="stopDetailsCompact; context: { $implicit: stop }"></ng-container>
      <div class="roll-card-reorder-actions">
        <button
          type="button"
          class="btn btn-link btn-sm roll-card-reorder"
          title="Nach oben"
          [disabled]="i === 0"
          (mousedown)="$event.stopPropagation()"
          (click)="moveStopInTeam(team, i, -1, $event)"
        >
          <i class="feather ft-chevron-up"></i>
        </button>
        <button
          type="button"
          class="btn btn-link btn-sm roll-card-reorder"
          title="Nach unten"
          [disabled]="i === stops.length - 1"
          (mousedown)="$event.stopPropagation()"
          (click)="moveStopInTeam(team, i, 1, $event)"
        >
          <i class="feather ft-chevron-down"></i>
        </button>
      </div>
      <button
        type="button"
        class="btn btn-link btn-sm roll-card-remove"
        title="Zurück in {{ stop.source === 'delivery-suggestion' ? 'Liefervorschlag' : 'Import' }}"
        (mousedown)="$event.stopPropagation()"
        (click)="removeFromTeam(stop, team, $event)"
      >
        <i class="feather ft-x"></i>
      </button>
    </div>
  </ng-template>
</ng-template>

<ng-template #stopDetailHeader let-stop let-tourLeg="tourLeg">
  <div class="roll-card-detail-header">
    <span class="badge kontingent-badge" [ngClass]="getKontingentClass(stop)" *ngIf="stop.source !== 'delivery-suggestion' && stop.kontingentLabel">
      {{ stop.kontingentLabel }}
    </span>
    <span class="badge kontingent-badge badge-montage-lv" *ngIf="stop.source === 'delivery-suggestion' && (stop.montageFlag || '').toUpperCase() === 'J'">
      {{ getDeliverySuggestionListLabel(stop) }}
    </span>
    <span class="badge badge-secondary delivery-suggestion-badge" *ngIf="isDeliverySuggestionStop(stop)">{{ getDeliverySuggestionAuftragsartLabel(stop) }}</span>
    <span class="kv-number" *ngIf="stop.kaufvertragsnummer">{{ isDeliverySuggestionStop(stop) ? stop.kaufvertragsnummer : ('KV ' + stop.kaufvertragsnummer) }}</span>
    <span class="roll-card-detail-tour text-muted" *ngIf="tourLeg">
      <i class="feather ft-navigation"></i>
      {{ tourLeg.distance_text }}
      <i class="feather ft-clock"></i>
      {{ tourLeg.duration_text }}
    </span>
    <span class="badge badge-danger duplicate-badge" *ngIf="isDuplicateStop(stop)">Doppelt</span>
  </div>
</ng-template>

<ng-template #stopDetailBody let-stop>
  <div class="roll-card-detail-body">
    <div class="roll-card-detail-grid">
      <div class="roll-card-detail-col">
        <div class="roll-card-detail-field" *ngIf="stop.customerName">
          <i class="feather ft-user detail-icon"></i>
          <span class="roll-card-detail-customer">{{ stop.customerName }}</span>
        </div>
        <div class="roll-card-detail-field">
          <i class="feather ft-map-pin detail-icon"></i>
          <span>{{ stop.address }}</span>
        </div>
      </div>
      <div class="roll-card-detail-col">
        <div class="roll-card-detail-field" *ngIf="stop.termin">
          <i class="feather ft-calendar detail-icon"></i>
          <span>Termin: {{ formatStopTermin(stop.termin) }}</span>
        </div>
        <div class="roll-card-detail-field" *ngIf="getStopFilialeLabel(stop)">
          <i class="feather ft-home detail-icon"></i>
          <span>{{ getStopFilialeLabel(stop) }}</span>
        </div>
        <div class="roll-card-detail-field" *ngIf="stop.positionCount">
          <i class="feather ft-list detail-icon"></i>
          <span>{{ stop.positionCount }} Position(en)<span *ngIf="stop.artikelCount"> · {{ stop.artikelCount }} Artikel</span></span>
        </div>
        <div class="roll-card-detail-field" *ngIf="stop.source === 'delivery-suggestion' && stop.lieferfaehigSeit">
          <i class="feather ft-truck detail-icon"></i>
          <span>Lieferfähig seit: {{ stop.lieferfaehigSeit }}</span>
        </div>
        <div class="roll-card-detail-field" *ngIf="stop.source === 'delivery-suggestion' && stop.zusatztext">
          <i class="feather ft-info detail-icon"></i>
          <span>{{ stop.zusatztext }}</span>
        </div>
      </div>
    </div>

    <div class="roll-card-detail-metrics">
      <div class="roll-card-detail-metric" *ngIf="hasKostenInfo(stop)">
        <i class="feather ft-tag detail-icon"></i>
        <div>
          <div class="metric-value">{{ formatCurrency(getStopKostenGesamt(stop)) }}</div>
          <div class="metric-sub text-muted">
            (Lief. {{ formatCurrency(stop.lieferkostenEK) }} + Mont. {{ formatCurrency(stop.montagekostenEK) }}<span *ngIf="getStopDistanceSurcharge(stop) > 0"> + Zuschlag {{ formatCurrency(getStopDistanceSurcharge(stop)) }}</span>)
          </div>
        </div>
      </div>
      <div class="roll-card-detail-metric" *ngIf="getStopServiceTypeFullLabel(stop) || getStopPrimaryArticleLabel(stop)">
        <i class="feather ft-settings detail-icon"></i>
        <div>
          <div class="metric-value" *ngIf="getStopServiceTypeFullLabel(stop)">{{ getStopServiceTypeFullLabel(stop) }}</div>
          <div class="metric-sub text-muted" *ngIf="getStopPrimaryArticleLabel(stop)">{{ getStopPrimaryArticleLabel(stop) }}</div>
        </div>
      </div>
      <div class="roll-card-detail-metric roll-card-detail-metric-specs" *ngIf="hasStopGewicht(stop) || hasStopVolumen(stop)">
        <span *ngIf="hasStopGewicht(stop)">
          <i class="feather ft-layers detail-icon"></i>
          {{ formatGewicht(stop) }}
        </span>
        <span *ngIf="hasStopVolumen(stop)">
          <i class="feather ft-package detail-icon"></i>
          {{ formatVolumen(stop) }}
        </span>
      </div>
      <div class="roll-card-detail-metric" *ngIf="hasCompactMontageZeit(stop)">
        <i class="feather ft-clock detail-icon"></i>
        <div>
          <div class="metric-value">{{ formatMontageZeit(stop) }}</div>
          <div class="metric-sub text-muted">Montage</div>
        </div>
      </div>
    </div>

    <div class="roll-card-meta roll-card-radius-warning text-danger" *ngIf="isStopOutsideBranchRadius(stop)">
      Außerhalb {{ branchRadiusKm }} km ({{ formatStopDistanceFromBranch(stop) }})
    </div>
    <div class="roll-card-status text-muted" *ngIf="stop.geocoding">Geocoding …</div>
    <div class="roll-card-status text-danger" *ngIf="stop.geocodingFailed">Adresse nicht gefunden</div>

    <div class="roll-card-detail-footer">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary btn-detail-edit"
        *ngIf="hasArticles(stop)"
        title="Artikel anzeigen"
        (mousedown)="$event.stopPropagation()"
        (click)="openArticlesDialog(stop, $event)"
      >
        Bearbeiten
      </button>
      <span class="roll-card-detail-coords text-success" *ngIf="!stop.geocoding && !stop.geocodingFailed && stop.lat">
        {{ stop.lat | number:'1.4-4' }}, {{ stop.lng | number:'1.4-4' }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #stopDetailsCompact let-stop>
  <div
    class="roll-card-content roll-card-content-compact"
    (dblclick)="openArticlesDialog(stop, $event)"
    [title]="hasArticles(stop) ? 'Doppelklick: Artikel anzeigen' : ''"
  >
    <div class="compact-line compact-line-primary">
      <span class="compact-kv" *ngIf="stop.kaufvertragsnummer">{{ stop.kaufvertragsnummer }}</span>
      <span class="compact-nachname" *ngIf="getStopNachnameLabel(stop)">{{ getStopNachnameLabel(stop) }}</span>
      <span class="compact-plz" *ngIf="getStopPlzLabel(stop)">{{ getStopPlzLabel(stop) }}</span>
      <span class="compact-ort" *ngIf="getStopOrtLabel(stop)">{{ getStopOrtLabel(stop) }}</span>
      <span class="compact-fallback-address compact-kv-muted" *ngIf="!stop.kaufvertragsnummer && !getStopPlzLabel(stop)">{{ stop.address }}</span>
      <span class="badge badge-danger duplicate-badge compact-duplicate-badge" *ngIf="isDuplicateStop(stop)">Doppelt</span>
      <span class="compact-status-icon" *ngIf="stop.geocoding" title="Geocoding">
        <i class="feather ft-loader"></i>
      </span>
      <span class="compact-status-icon text-danger" *ngIf="stop.geocodingFailed" title="Adresse nicht gefunden">
        <i class="feather ft-alert-circle"></i>
      </span>
    </div>
    <div class="compact-line compact-line-service" *ngIf="hasCompactServiceInfo(stop)">
      <span class="compact-service" *ngIf="getStopServiceTypeCompactLabel(stop)">{{ getStopServiceTypeCompactLabel(stop) }}</span>
      <span class="compact-me" *ngIf="formatCompactMontageMenge(stop)">{{ formatCompactMontageMenge(stop) }}</span>
      <span class="compact-zeit" *ngIf="hasCompactMontageZeit(stop)">{{ formatMontageZeit(stop) }}</span>
      <span class="compact-wert" *ngIf="hasKostenInfo(stop)">{{ formatCompactGesamt(stop) }}</span>
    </div>
    <span class="compact-radius-warning" *ngIf="isStopOutsideBranchRadius(stop)">
      &gt; {{ branchRadiusKm }} km
    </span>
  </div>
</ng-template>
